(function (angular, addEventListener, removeEventListener, bodyScrollLock) {
  "use strict";

  angular.module("Toyota.Services").service("ScrollLock", [
    function () {
      var exports = this;

      var isTouchMoveScrollingDisabled = false;

      var lastOptions = {};

      exports.lock = function (overrides) {
        var options = {
          innerScrollingTarget: null,
        };

        $.extend(options, overrides);

        if (options.innerScrollingTarget) {
          bodyScrollLock.disableBodyScroll(options.innerScrollingTarget);
        } else {
          isTouchMoveScrollingDisabled = true;
        }

        exports.isLocked = true;

        lastOptions = angular.copy(options);
      };

      exports.unlock = function () {
        if (lastOptions.innerScrollingTarget) {
          bodyScrollLock.clearAllBodyScrollLocks();
        } else {
          isTouchMoveScrollingDisabled = false;
        }

        exports.isLocked = false;
      };

      function init() {
        /*
         * Patch for Owl Carousel and Range Spinner cases, where we need
         * to have touchmove pass-through, but where we have no need to
         * allow browser-provided momentum scrolling within the module
         * itself
         *
         * https://github.com/willmcpo/body-scroll-lock/issues/82
         */

        var hasPassiveEvents = false;

        if (typeof window !== "undefined") {
          var passiveTestOptions = {
            get passive() {
              hasPassiveEvents = true;
              return undefined;
            },
          };
          addEventListener("testPassive", null, passiveTestOptions);
          removeEventListener("testPassive", null, passiveTestOptions);
        }

        document.addEventListener(
          "touchmove",
          function (e) {
            if (isTouchMoveScrollingDisabled) {
              e.preventDefault();
            }
          },
          hasPassiveEvents
            ? {
                passive: false,
              }
            : undefined
        );
      }

      init();

      return exports;
    },
  ]);
})(window.angular, window.addEventListener, window.removeEventListener, window.bodyScrollLock);
